export const JACKPOTS_CATEGORY = 'jackpots';
export const AllGamesText = 'All Games';

interface JackpotGame {
    sid: string;
    game: string;
    name: string;
}

interface JackpotBackgroundImage {
    Src: string;
    Alt: string;
    Width: number;
    Height: number;
}

export enum SUB_JACKPOT_TYPES {
    VALUE = 'TRIGGER_VALUE',
    TIME = 'TRIGGER_TIME',
    RANDOM = 'TRIGGER_RANDOM',
}

export interface SubJackpotDetail {
    id: string;
    name: string;
    subJackpotAmount: string | null;
    triggerInfo: string | null;
    lastWinTime: string | null;
    lastWinAmount: string | null;
    amount: string | null;
    jackpotFeedId: string;
    subJackpotName: string;
    subJackpotValue: string;
    backgroundImage: string | null;
    jackpotImage: null;
    content: null;
    ctaLink: null;
    subJPCompPercent: string;
    triggerType: SUB_JACKPOT_TYPES;
    subJackpotThreshold: string | null;
    mustBeWonByText: string | null;
    mustPayWithinText: string | null;
}

export interface JackpotTile {
    minimumBet: string;
    totalJackpotAmountLabel: string;
    imageBorder: string;
    imageBackgroundColor: string;
    jackpotId: string;
    jackpotGroupId: string;
    jackpotType: string;
    jackpotGroupName: string | null;
    backgroundColor: string;
    subjackpotInfoColor: string;
    description: string;
    amount: string;
    gameName: string;
    value: string;
    gamesList: string[];
    gamesAvailable: JackpotGame[];
    backgroundImage: JackpotBackgroundImage;
    bannerBackgroundImage: JackpotBackgroundImage;
    jackpotImage: JackpotBackgroundImage;
    content: string | null;
    messages: string | null;
    attributes: string | null;
    ctaLink: string | null;
    globalJackpotAttributes: string | null;
    jpTickingValue: number;
    truncateDecimalsInJPValue: boolean;
    highestCompletedPercentage: string;
    subJackpotDetails: SubJackpotDetail[];
    isHotJackpotGroup: boolean;
    jpCurrency: string;
    lastWinAmount: string;
    lastWinTime: string;
    jackpotTypeBackgroundColor: string;
    jackpotGroupTextColor: string;
    jackpotTypeColor: string;
    subJackpotInfoTextColor: string;
    progressbarFillColor: string;
    progressiveJackpotText: string;
    showValueSubjackpots: boolean;
    startingatTime: string;
    showTimer: boolean;
    showLastWin: boolean;
    tileBorderColor: string;
    viewGamesTextColor: string;
    timeLeftText: string;
    viewGamesText: string;
    lastwinText: string;
    jackpotTileType: string;
    maxText: string;
    progressbarColor: string;
    mustBeWonByLabel: string;
    mustPayWithinLabel: string;
    promoLabel: string;
    minimumBetLabel: string;
}
